<template>
  <BaseModalEditCreate
    mode="select"
    :is-modified="false"
    :close-on-outside-click="false"
    max-width="extra"
    :title="$t('salesDocuments.mediatorModalSelect')"
    @dismiss-changes="onDismiss"
    @save="onSave">
    <template #form>
      <div class="overflow-hidden h-full grid grid-rows-[auto_1fr]">
        <div class="w-full h-full overflow-x-hidden">
          <BaseTable
            v-if="list"
            table-id="sales-modal-costumers"
            :total-records="totalRecords"
            :headers="treaderHeaders"
            :list="filteredTraders"
            only-search
            hide-multiselect-delete
            hide-multiselect-download
            clickable
            disable-multiselect
            :selected-item="selectedTrader"
            @table-item-clicked="onSelectRow"
            @refresh-data="onRefreshData" />
        </div>
      </div>
    </template>
  </BaseModalEditCreate>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import BaseModalEditCreate from '@/components/common/BaseModalEditCreate.vue';
import BaseTable from '@/components/common/BaseTable.vue';
import type { TableFilterData } from '@/types/Base';
import type { Trader } from '@/types/Traders';

const props = defineProps<{
  list: Partial<Trader>[];
  totalRecords?: number;
}>();

const emit = defineEmits(['refreshData', 'rowSelect', 'dismiss']);

const filteredTraders = computed(() => {
  return props.list.filter((x) => !x.deleted);
});

const treaderHeaders = [
  { value: 'code', text: 'Code', type: 'text', active: true },
  { value: 'name', text: 'Name', type: 'text', active: true },
  { value: 'taxNumber', text: 'Tax Number', type: 'text', active: true },
  { value: 'trader.code', text: 'Trader Code', type: 'text', active: true },
  { value: 'address', text: 'Address', type: 'text', active: true },
  { value: 'zipCode', text: 'Zip Code', type: 'text', active: true },
  { value: 'city', text: 'city', type: 'text', active: true },
];

const selectedTrader = ref<Trader>();
function onSelectRow(trader: Trader) {
  selectedTrader.value = trader;
}

function onRefreshData(data: TableFilterData) {
  let newPageTotal;
  if (props.totalRecords && data.itemsPerPage) {
    newPageTotal = props.totalRecords / data.itemsPerPage;
  }
  if (newPageTotal && data.page && newPageTotal < data.page) data.page = 1;
  emit('refreshData', data);
}

function onDismiss() {
  emit('dismiss');
}

function onSave() {
  if (selectedTrader.value) emit('rowSelect', selectedTrader.value);
}
</script>
